export default [

    // accesso utente
    {

        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "login" */ './views/access'),
        meta: {layout: 'layout-login', requiresAuth: false, title: 'headers.access-title'}
    },

    // ripristino password
    {
        path: '/login/recover',
        name: 'recover',
        component: () => import(/* webpackChunkName: "login" */ './views/recover'),
        meta: {layout: 'layout-login', requiresAuth: false, title: 'headers.recover-title'}
    }
];